import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { RoleRedirectService } from 'app/core/auth/services/role-redirect.service';
import { UserService } from 'app/core/user/user.service';
import { of, switchMap, catchError } from 'rxjs';

/** Password recovery routes must be reachable even with an active session. */
const ALLOW_WHILE_AUTHENTICATED = ['/auth/reset-password', '/auth/forgot-password'];

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const roleRedirectService = inject(RoleRedirectService);
  const userService = inject(UserService);

  // Check the authentication status
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        // If the user is authenticated...
        if (authenticated) {
          const path = state.url.split('?')[0];
          if (userService.currentUser?.mustResetPassword) {
            if (path.startsWith('/auth/reset-password')) {
              return of(true);
            }
            return of(router.parseUrl('/auth/reset-password?flow=temporary'));
          }
          if (ALLOW_WHILE_AUTHENTICATED.some((allowed) => path.startsWith(allowed))) {
            return of(true);
          }

          // Get the appropriate redirect URL based on user role
          const redirectUrl = roleRedirectService.getDefaultRedirectUrl();
          return of(router.parseUrl(redirectUrl));
        }

        // Allow the access
        return of(true);
      }),
      catchError((error) => {
        console.error('❌ NoAuthGuard error:', error);
        // On error, allow access to prevent blocking auth pages
        return of(true);
      }),
    );
};
